"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("stremio/core");
var Platform_1 = require("stremio/common/Platform");
var CONSTANTS_1 = require("stremio/common/CONSTANTS");
var interfaceScale_1 = require("stremio/common/interfaceScale");
var useInterfaceScale = function (profile) {
    var _a;
    var core = (0, core_1.useCore)();
    var shell = (0, Platform_1.usePlatform)().shell;
    var settingsRef = (0, react_1.useRef)(profile.settings);
    var scale = (0, interfaceScale_1.normalizeInterfaceScale)((_a = profile.settings) === null || _a === void 0 ? void 0 : _a.interfaceScale);
    (0, react_1.useEffect)(function () {
        settingsRef.current = profile.settings;
    }, [profile.settings]);
    var changeInterfaceScale = (0, react_1.useCallback)(function (action) {
        var settings = settingsRef.current;
        if (!settings)
            return;
        var current = (0, interfaceScale_1.normalizeInterfaceScale)(settings.interfaceScale);
        var index = CONSTANTS_1.INTERFACE_SCALES.indexOf(current);
        var next = action === 'reset' ? 100 : CONSTANTS_1.INTERFACE_SCALES[Math.max(0, Math.min(CONSTANTS_1.INTERFACE_SCALES.length - 1, index + (action === 'increase' ? 1 : -1)))];
        if (next === settings.interfaceScale)
            return;
        settingsRef.current = __assign(__assign({}, settings), { interfaceScale: next });
        core.transport.dispatch({
            action: 'Ctx',
            args: { action: 'UpdateSettings', args: settingsRef.current }
        });
    }, [core.transport]);
    (0, react_1.useEffect)(function () {
        if (shell.active && !shell.state.initialized)
            return;
        if (shell.capabilities.nativeInterfaceScale) {
            (0, interfaceScale_1.setInterfaceScale)(1);
            shell.send('win-set-interface-scale', { scale: scale });
        }
        else {
            (0, interfaceScale_1.setInterfaceScale)(scale / 100);
        }
    }, [scale, shell]);
    (0, react_1.useEffect)(function () {
        var onScale = function (action) {
            if (action === 'increase' || action === 'decrease' || action === 'reset') {
                changeInterfaceScale(action);
            }
        };
        shell.on('interface-scale', onScale);
        return function () { shell.off('interface-scale', onScale); };
    }, [changeInterfaceScale, shell]);
    return changeInterfaceScale;
};
exports.default = useInterfaceScale;
